import styled from 'styled-components';
import { Space, Typography } from 'antd';
import { ListItemData } from '../utils/mapData';
import { useBookmarkContext } from 'contexts/bookmark';
import BookmarkIcon from 'assets/images/bookmark-icon.svg';
import BookmarkedIcon from 'assets/images/bookmarked-icon.svg';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils';

const { Text, Title } = Typography;

const Wrapper = styled.div<{ isActive?: boolean }>`
  padding: 24px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  border-radius: 8px;
  cursor: pointer;
  ${(props) => props.isActive && 'outline: 2px solid #C21B17;'}
`;

const BookmarkWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ClickableSpan = styled.span`
  cursor: pointer;
`;

interface ListItemProps {
  isActive?: boolean;
  handleOnListItemSelected: (rowId: number | string, latitude: number, longitude: number) => void;
  data: ListItemData;
  searchQuery?: string;
}

// const englishRegex = /^[A-Za-z0-9]*$/;

const ListItem = ({ isActive, handleOnListItemSelected, data: itemData /*, searchQuery*/ }: ListItemProps) => {
  const { addBookmark, removeBookmark } = useBookmarkContext();
  const { i18n } = useTranslation();
  const isBookmarked = !!itemData.bookmarkId;
  const { bookmarkId, title1, title1_cn, title2, title2_cn, address, address_cn, phone, latitude, longitude, itemId } =
    itemData;

  // const isEnglishSearchQuery = searchQuery ? englishRegex.test(searchQuery) : isLocaleEnglish(i18n.language);

  // const _title1 = isEnglishSearchQuery ? title1 : title1_cn;
  // const _title2 = isEnglishSearchQuery ? title2 : title2_cn;
  // const _address = isEnglishSearchQuery ? address : address_cn;
  const _title1 = isLocaleEnglish(i18n.language) ? title1 : title1_cn;
  const _title2 = isLocaleEnglish(i18n.language) ? title2 : title2_cn;
  const _address = isLocaleEnglish(i18n.language) ? address : address_cn;

  const handleOnClick = async () => {
    if (isBookmarked) {
      if (bookmarkId) {
        removeBookmark(bookmarkId);
      }
    } else {
      addBookmark(itemData);
    }
  };

  return (
    <Wrapper
      isActive={isActive}
      onClick={() => {
        itemId && handleOnListItemSelected(itemId, latitude ?? 0, longitude ?? 0);
      }}
    >
      <BookmarkWrapper>
        <Space direction="vertical">
          {_title1 && <Text>{_title1}</Text>}
          {_title2 && <Title level={4}>{_title2}</Title>}
        </Space>
        <ClickableSpan onClick={handleOnClick}>
          {isBookmarked ? <img src={BookmarkedIcon} alt="bookmarked" /> : <img src={BookmarkIcon} alt="bookmark" />}
        </ClickableSpan>
      </BookmarkWrapper>
      <Text type="secondary">{_address}</Text>
      <Text type="secondary">{phone ? `${phone}` : 'N/A'}</Text>
    </Wrapper>
  );
};

export default ListItem;
